import { Component, OnInit } from '@angular/core';
import {environment} from "../../../environments/environment";
import { ConfigurationService } from 'src/app/services/configuration.service';

@Component({
  selector: 'app-mes-contrats',
  templateUrl: './mes-contrats.component.html',
  styleUrls: ['./mes-contrats.component.scss']
})
export class MesContratsComponent implements OnInit {

  constructor(private configurationService: ConfigurationService) { }

  ngOnInit(): void {
  }
  configuration = this.configurationService.get();

}
